<template></template>
<script setup>

onLaunch(() => {
  const { platform } = uni.getSystemInfoSync()

  if (platform === "android") {
    const permissionListener = uni.createRequestPermissionListener()

    permissionListener.onConfirm((e) => {
      console.log("权限类型: ", e)
      uni.navigateTo({
        url: "/pages/auth/index" + "?type=" + JSON.stringify(e),
        complete(e) {
          console.log(e)
        },
      })
    })
    permissionListener.onComplete((e) => {
      console.log("权限申请完成")
      // 拒绝时也会走需要处理一下，提示拒绝手动开启
      const pages = getCurrentPages()
      const currentPages = pages[pages.length - 1]

      console.log("当前页面: ", currentPages.route)

      if (currentPages.route === "pages/auth/index") {
        uni.navigateBack()
      }
    })
  }
})

</script>
<style lang="scss">
@import '@/style/index.scss';
@import "@/uni.scss";

page {
  background: #fff8f3;
  color: #3d2b24;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.page {
  padding: 28rpx 32rpx 48rpx;
}

.eyebrow {
  margin-bottom: 8rpx;
  color: #d58d6b;
  font-size: 23rpx;
  font-weight: 700;
  letter-spacing: 2rpx;
}

.page-title {
  font-size: 46rpx;
  font-weight: 700;
}

.card {
  background: #fff;
  border: 1rpx solid #f2dfd2;
  border-radius: 28rpx;
  box-shadow: 0 14rpx 32rpx rgba(190, 102, 57, 0.1);
}

.primary-button {
  width: 100%;
  padding: 24rpx;
  color: #fff;
  font-size: 28rpx;
  font-weight: 700;
  background: linear-gradient(135deg, #f5c3a7, #eca47f);
  box-shadow: 0 12rpx 24rpx rgba(219, 144, 103, 0.18);
  border: 0;
  border-radius: 18rpx;
}

.section-title {
  font-size: 34rpx;
  font-weight: 700;
}

.empty {
  padding: 42rpx 20rpx;
  color: #9c7b6d;
  font-size: 26rpx;
  text-align: center;
  border: 1rpx dashed #ead8ce;
  border-radius: 20rpx;
}

/* 归云暖杏色主题：覆盖页面中遗留的冷色卡片与背景。 */
.page { background: #fffaf7 !important; color: #523a30 !important; }
.card { background: #fffdfb !important; border-color: #f1e0d6 !important; box-shadow: 0 14rpx 32rpx rgba(195, 126, 91, 0.09) !important; }
.welcome { background: linear-gradient(135deg, #f7cbb1, #eeaf8d) !important; box-shadow: 0 16rpx 30rpx rgba(223, 154, 113, 0.22) !important; }
.avatar,.guest-icon,.member-avatar { background: #fee8da !important; color: #da8c69 !important; }
.streak { background: #fff0df !important; color: #bd805f !important; }
.day { color: #b69b8d !important; }.day-number { background: #f9ede6 !important; }.checked { color: #dc9470 !important; }.checked .day-number { background: #fee4d4 !important; }.today .day-number { outline-color: #efb391 !important; }
.service-item { border-color: #f0ded3 !important; background: #fffdfb !important; }.service-icon { background: #fff0e7 !important; }.service-item text { color: #593e32 !important; }
.member { background: linear-gradient(135deg, #fff5ed, #fffdfb) !important; }.member>text,.text-button { color: #d98c69 !important; }
.note-content,.note-date,.subcopy,.sync-status.offline { color: #9b796b !important; }.editor input,.editor textarea,.picker-value,.field input { background: #fffaf6 !important; border-color: #ecd8cd !important; }

// test

button::after {
	border: none;
}

swiper,
scroll-view {
	flex: 1;
	height: 100%;
	overflow: hidden;
}

image {
	width: 100%;
	height: 100%;
	vertical-align: middle;
}

.ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.ellipsis-2 {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.ellipsis-3 {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}
</style>
